export default "__VITE_ASSET__a0672b69__"